module.exports = "/_next/static/images/logo-telecom-center-1830fe87649983ba3dda4b8693a9474b.svg";